// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__C19-5","reminder":"LoginPage_reminder__tK5UX","errorBox":"LoginPage_errorBox__YMCRS"};